import { createAsyncThunk } from '@reduxjs/toolkit';
import { _appointmentStudyUrls } from '@custom/Utils/constants/apiUrls';
import { getCloudPACSToken } from '@custom/Utils/authUtils';

const getAppointmentStudy = createAsyncThunk('getAppointmentStudy', async (patientId: string) => {
  try {
    const url = new URL(_appointmentStudyUrls.get);
    const pacs_token = getCloudPACSToken();

    url.searchParams.append('limit', '21');
    url.searchParams.append('includefield', 'all');
    url.searchParams.append('offset', '0');
    url.searchParams.append('AccessionNumber', patientId);

    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${pacs_token}`,
      }
    });

    if (!response.ok) {
      throw new Error('Failed to fetch patient details');
    }

    return await response.json();
  } catch (error) {
    return Promise.reject(error);
  }
});

export default getAppointmentStudy;
